import { faker } from "@faker-js/faker";
import {
  AdministrationApproach,
  ClinicalEventType,
  ClinicalProductType,
  PrescribableItemType,
  RateUnit,
  TimeUnit,
} from "elephant-web/gql";
import {
  DoseUnit,
  type Prescription,
} from "../../src/global-providers/rxdb-provider/collections/prescription";
export const makePrescription = (overrides = {}): Prescription => ({
  id: faker.string.uuid(),
  administrationApproach: faker.helpers.arrayElement([
    AdministrationApproach.AsRequired,
    AdministrationApproach.Outpatient,
    AdministrationApproach.Scheduled,
    AdministrationApproach.Stat,
  ]),
  cancellationDetails: null,
  clinicalEvent: {
    id: faker.string.uuid(),
    type: faker.helpers.arrayElement([
      ClinicalEventType.AncEncounter,
      ClinicalEventType.Visit,
      ClinicalEventType.Consultation,
    ]),
  },
  prescribableItemType: faker.helpers.enumValue(PrescribableItemType),
  prescribableItemFreeText: faker.helpers.arrayElement([
    null,
    faker.string.alpha(),
  ]),
  clinicalProduct: {
    id: faker.string.uuid(),
    type: faker.helpers.arrayElement([
      ClinicalProductType.Amp,
      ClinicalProductType.Vmp,
    ]),
  },
  dosage: {
    value: faker.number.float({ min: 0.1, max: 1000, precision: 0.1 }),
    unit: faker.helpers.arrayElement(Object.values(DoseUnit)),
  },
  facilityId: faker.string.uuid(),
  frequency: {
    value: faker.number.int({ min: 1, max: 4 }),
    unit: faker.helpers.arrayElement(Object.values(TimeUnit)),
  },
  meta: {
    createdAt: faker.date.past().toISOString(),
    updatedAt: faker.date.past().toISOString(),
    createdByUserId: faker.string.uuid(),
    updatedByUserId: faker.string.uuid(),
  },
  minimumDoseInterval: null,
  note: faker.lorem.paragraph(),
  patientId: faker.string.uuid(),
  prescribedByUserId: faker.string.uuid(),
  rate: {
    value: faker.number.int({ min: 1, max: 100 }),
    unit: faker.helpers.arrayElement(Object.values(RateUnit)),
  },
  startsAt: faker.date.soon().toISOString(),
  stopsAt: faker.date.future().toISOString(),
  ...overrides,
});

export const makePrescriptions = (
  count: number,
  overrides: Partial<Prescription> = {},
): Prescription[] => {
  return Array.from({ length: count }, () => makePrescription(overrides));
};
